import {Component, computed, inject, signal} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MobileAreaCodeComponent} from '../../../form/43-1-mobile-area-code/mobile-area-code.component'
import {MobileComponent} from '../../../form/43-2-mobile/mobile.component'
import {PrivateEmailComponent} from '../../../form/47-private-email/private-email.component'
import {KycService} from '../../../services/kyc.service'
import {ReadOnlyComponent} from '../../../form/01-read-only/read-only.component'
import {swedenCountyList} from '../../../types'


@Component({
  selector: 'spb-applicant',
  templateUrl: './applicant.component.html',
  imports: [ReactiveFormsModule,
    MobileComponent,
    PrivateEmailComponent,
    FormsModule,
    MobileAreaCodeComponent, ReadOnlyComponent
  ],
  styleUrl: './applicant.component.scss'
})
export class ApplicantComponent {
  public kycService = inject(KycService)

  public country = computed(() => {
    return swedenCountyList.find(c => c.code === this.kycService.kycModel.country)?.name
  })

  public valids = [
    signal(false),
    signal(false),
    signal(false)
  ]

  public valid = computed(() => {
    return this.valids[0]() && this.valids[1]() && this.valids[2]()
  })
}
